<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-progress #progress (stateChange)="getCurrentStep($event)">
        <!--Step 1 Personal Information -->
        <app-progress-step>
            <h2 class="step-header">Personal Information</h2>
            <hr>
            <div class="step-form">
                <div class="full-width row">
                    <img [src]="imageSrc" *ngIf="imageSrc" style="height: 300px; width:500px">
                    <div class="form-group">
                        <!-- <input formControlName="file" type="file" class="form-control"> -->
                    </div>
    
                    <div class="col-md-5 form-floating">
                        <input type="text" class="form-control" formControlName="lastNameInput" placeholder="Last Name">
                        <label for="lastNameInput" required>Last Name</label>            
                    </div>
                    <div class="col-md-5 form-floating">
                        <input type="text" class="form-control" formControlName="firstNameInput" placeholder="First Name">
                        <label for="firstNameInput">First Name</label>
                    </div>
                    <div class="col-md-2 form-floating">
                        <input type="text" class="form-control" formControlName="middleInitialInput" placeholder="M.I">
                        <label for="middleInitialInput">M.I</label>
                    </div>
                    <div class="col-md-12 form-floating">
                        <input type="text" class="form-control" formControlName="streeAddressInput" placeholder="Street Address">
                        <label for="streeAddressInput">Street Address</label>
                    </div>
                    <div class="col-md-5 form-floating">
                        <input type="text" class="form-control" formControlName="cityInput" placeholder="City">
                        <label for="cityInput">City</label>
                    </div>
                    <div class="col-md-5 form-floating">
                        <input type="text" class="form-control" formControlName="barangayInput" placeholder="Barangay">
                        <label for="barangayInput">Barangay</label>
                    </div>
                    <div class="col-md-2 form-floating">
                        <input type="text" class="form-control" formControlName="zipCodeInput" placeholder="Zipcode">
                        <label for="zipCodeInput">Zipcode</label>
                    </div>
                    <div class="col-md-5 form-floating">
                        <input type="text" class="form-control" formControlName="cellNumberInput" placeholder="Cellphone Number">
                        <label for="cellNumberInput">Cellphone Number</label>
                    </div>
                    <div class="col-md-3 form-floating">
                        <select formControlName="genderInput" class="form-select  ">
                            <option selected>Choose...</option>
                            <option>Male</option>
                            <option>Female</option>
                        </select>
                        <label for="genderInput">Gender</label>
                    </div>
                    <div class="col"></div>
                    <div class="col-md-5 form-floating">
                        <input type="date" class="form-control" formControlName="birthDateInput" placeholder="Date of Birth">
                        <label for="birthDateInput">Date of Birth</label>
                    </div>
                    <div class="col-md-5 form-floating">
                        <input type="text" class="form-control" formControlName="birthPlaceInput" placeholder="Place of Birth">
                        <label for="birthPlaceInput">Place of Birth</label>
                    </div>
                    <div class="col-md-2 form-floating">
                        <input type="number" class="form-control" formControlName="ageInput" placeholder="Age">
                        <label for="ageInput">Age</label>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="text" class="form-control" formControlName="nationalityInput" placeholder="Nationality">
                        <label for="nationalityInput">Nationality</label>
                    </div>
                    <div class="col-md-3 form-floating input-group">
                        <input type="text" class="form-control" formControlName="heightInput">
                        <label for="heightInput">Height</label>
                        <span class="input-group-text">cm</span>
                    </div>
                    <div class="col-md-3 form-floating input-group">
                        <input type="text" class="form-control" formControlName="weightInput">
                        <label for="weightInput">Weight</label>
                        <span class="input-group-text">kg</span>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="text" class="form-control" formControlName="religionInput" placeholder="Religion">
                        <label for="religionInput">Religion</label>
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-2 mt-2"><label for=""><strong>STATUS:</strong></label></div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="statusCheckbox" value="Single">
                        <label class="form-check-label" for="statusCheckBox1">Single</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="statusCheckbox" value="Married">
                        <label class="form-check-label" for="statusCheckBox2">Married</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="statusCheckbox" value="Divorce">
                        <label class="form-check-label" for="statusCheckBox3">Divorce</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="statusCheckbox" value="Widow">
                        <label class="form-check-label" for="statusCheckBox4">Widow</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="statusCheckbox" value="Others">
                        <label class="form-check-label" for="statusCheckBox5">Others</label>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="text" class="form-control" formControlName="passportInput" placeholder="Passport">
                        <label for="passportInput">Passport</label>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="date" class="form-control" formControlName="dateExpInput" placeholder="Passport">
                        <label for="dateExpInput">Date of Expiry</label>
                    </div>
                    <div class="col-md-4 mt-2"><label for=""><strong>UNIFIED SSS ID:</strong></label></div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="sssIdCheckbox" value="Yes">
                        <label class="form-check-label" for="sssIdCheckbox1">YES</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="sssIdCheckbox" value="No">
                        <label class="form-check-label" for="sssIdCheckbox2">NO</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="sssIdCheckbox" value="On Process">
                        <label class="form-check-label" for="sssIdCheckbox3">ON PROCESS</label>
                    </div>
                    <div class="col"></div>
                    <div class="col-md-4 mt-2"><label for=""><strong>BIRTH CERTIFICATE:</strong></label></div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="birthCertCheckBox" value="Yes">
                        <label class="form-check-label" for="birthCertCheckBox1">YES</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="birthCertCheckBox" value="No">
                        <label class="form-check-label" for="birthCertCheckBox2">NO</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="birthCertCheckBox" value="On Process">
                        <label class="form-check-label" for="birthCertCheckBox3">ON PROCESS</label>
                    </div>
                    <div class="col"></div>
                    <div class="col-md-4 mt-2"><label for=""><strong>DIPLOMA:</strong></label></div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="diplomaCheckBox" value="Yes">
                        <label class="form-check-label" for="diplomaCheckBox1">YES</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="diplomaCheckBox" value="No">
                        <label class="form-check-label" for="diplomaCheckBox2">NO</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="diplomaCheckBox" value="On Process">
                        <label class="form-check-label" for="diplomaCheckBox3">ON PROCESS</label>
                    </div>
                    <div class="col"></div>
                    <div class="col-md-4 mt-2"><label for=""><strong>REFERRAL:</strong></label></div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="referralCheckBox" value="Internet">
                        <label class="form-check-label" for="referralCheckBox1">Internet</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="referralCheckBox" value="Walk-in">
                        <label class="form-check-label" for="referralCheckBox2">Walk-in</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="referralCheckBox" value="Friend">
                        <label class="form-check-label" for="referralCheckBox3">Friend</label>
                    </div>
                    <div class="status col-md-2 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="referralCheckBox" value="Others">
                        <label class="form-check-label" for="referralCheckBox4">Others</label>
                    </div>
                </div>
                <div class="btn-right d-flex align-items-center justify-content-between">
                    <button progressStepPrev class="btn btn-secondary" type="button">prev</button>
                    <button progressStepNext class="btn btn-primary" type="button">next</button>
                </div>
            </div>
        </app-progress-step>
        
        <!--Step 2 Family Background -->
        <app-progress-step>
            <h2 class="step-header">Family Background</h2>
            <hr>
            <div class="step-form">
                    <h6 class="text-center pt-4">FATHER</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="fatherNameInput" placeholder="Father Name">
                            <label for="fatherNameInput">Father Name</label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="fatherAgeInput" placeholder="Age">
                            <label for="fatherAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="fatherJobTitleInput" placeholder="Job Title">
                            <label for="fatherJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">MOTHER</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="motherNameInput" placeholder="Mother Name">
                            <label for="motherNameInput">Mother Name</label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="motherAgeInput" placeholder="Age">
                            <label for="motherAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="motherJobTitleInput" placeholder="Job Title">
                            <label for="motherJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">HUSTBAND / WIFE</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="partnerNameInput" placeholder="Hustban/Wife Name ">
                            <label for="partnerNameInput">Hustban/Wife Name </label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="partnerAgeInput" placeholder="Age">
                            <label for="partnerAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="partnerJobTitleInput" placeholder="Job Title">
                            <label for="partnerJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">BROTHER</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="brotherNameInput" placeholder="Brother's Name">
                            <label for="brotherNameInput">Brother's Name</label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="brotherAgeInput" placeholder="Age">
                            <label for="brotherAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="brotherJobTitleInput" placeholder="Job Title">
                            <label for="brotherJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">SISTER</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="sisterNameInput" placeholder="Sister's Name">
                            <label for="sisterNameInput">Sister's Name</label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="sisterAgeInput" placeholder="Age">
                            <label for="sisterAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="sisterJobTitleInput" placeholder="Job Title">
                            <label for="sisterJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">CHILDREN GIRL</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="childrenGirlNameInput" placeholder="Name">
                            <label for="childrenGirlNameInput">Name</label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="childrenGirlAgeInput" placeholder="Age">
                            <label for="childrenGirlAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="childrenGirlJobTitleInput" placeholder="Job Title">
                            <label for="childrenGirlJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">CHILDREN BOY</h6>
                    <div class="row">
                        <div class="col-md-6 form-floating">
                            <input type="text" class="form-control" formControlName="childrenBoyNameInput" placeholder="Name">
                            <label for="childrenBoyNameInput">Name</label>
                        </div>
                        <div class="col-md-2 form-floating">
                            <input type="number" class="form-control" formControlName="childrenBoyAgeInput" placeholder="Age">
                            <label for="childrenBoyAgeInput">Age</label>
                        </div>
                        <div class="col-md-4 form-floating">
                            <input type="text" class="form-control" formControlName="childrenBoyJobTitleInput" placeholder="Job Title">
                            <label for="childrenBoyJobTitleInput">Job Title</label>
                        </div>
                    </div>
                    <h2 class="step-header pt-5">Language Compentency</h2>
                    <hr>
                    <div class="mt-2 text-center"><label for=""><strong>ENGLISH</strong></label></div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="englishCheckBox" value="EXCELENT">
                        <label class="form-check-label" for="englishCheckBox1">EXCELENT</label>
                    </div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="englishCheckBox" value="GOOD">
                        <label class="form-check-label" for="englishCheckBox2">GOOD</label>
                    </div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="englishCheckBox" value="dimploma1">
                        <label class="form-check-label" for="englishCheckBox3">FAIR</label>
                    </div>
                    <div class="mt-2 text-center"><label for=""><strong>CHINESE</strong></label></div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="chineseCheckBox" value="EXCELENT">
                        <label class="form-check-label" for="chineseCheckBox1">EXCELENT</label>
                    </div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="chineseCheckBox" value="GOOD">
                        <label class="form-check-label" for="chineseCheckBox2">GOOD</label>
                    </div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="chineseCheckBox" value="FAIR">
                        <label class="form-check-label" for="chineseCheckBox3">FAIR</label>
                    </div>
                    <div class="mt-2 text-center"><label for=""><strong>OTHERS</strong></label></div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="otherCheckBox" value="EXCELENT">
                        <label class="form-check-label" for="otherCheckBox1">EXCELENT</label>
                    </div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="otherCheckBox" value="GOOD">
                        <label class="form-check-label" for="otherCheckBox2">GOOD</label>
                    </div>
                    <div class="status col-md-4 form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="otherCheckBox" value="FAIR">
                        <label class="form-check-label" for="otherCheckBox3">FAIR</label>
                    </div>
                    
                </div>
                <div class="btn-right d-flex align-items-center justify-content-between">
                    <button progressStepPrev class="btn btn-secondary" type="button">prev</button>
                    <button progressStepNext class="btn btn-primary" type="button">next</button>
                </div>
        </app-progress-step>
        <app-progress-step>
            <h2 class="step-header">Educational Background</h2>
            <hr>
            <div class="step-form">
                <h6 class="text-center pt-4">Elementary School</h6>
                    <div class="row">
                        <div class="col-md-12 form-floating">
                            <input type="text" class="form-control" formControlName="elemSchoolNameInput" placeholder="Name">
                            <label for="elemSchoolNameInput">Name & Address of school</label>
                        </div>
                        <div class="col-md-4 mt-3">
                            <div class="form-check ml-5">
                                <input class="form-check-input text-center" type="radio" formControlName="elemStatus" value="Undergrad">
                                <label class="form-check-label" for="elemUnderGradCheckBox">
                                    Undergrad
                                </label>
                            </div>
                            <div class="form-check ml-5">
                                <input class="form-check-input" type="radio" formControlName="elemStatus" value="Graduated">
                                <label class="form-check-label" for="elemGradCheckBox">
                                    Graduated
                                </label>
                            </div>
                        </div>
                        <div class="col-md-8 row mt-3">
                            <div class="col-md-2 offset-md-1">
                                <label for="">From</label>
                                <label for="">To</label>
                            </div>
                            <div class="col-md-8">
                                <input type="date" class="form-control mt-2" formControlName="elemDateFrom">
                                <input type="date" class="form-control mt-2" formControlName="elemDateTo">
                            </div>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">High School</h6>
                    <div class="row">
                        <div class="col-md-12 form-floating">
                            <input type="text" class="form-control" formControlName="highSchoolNameInput" placeholder="Name">
                            <label for="highSchoolNameInput">Name & Address of school</label>
                        </div>
                        <div class="col-md-4 mt-3">
                            <div class="form-check ml-5">
                                <input class="form-check-input text-center" type="radio" formControlName="highStatus" value="Undergrad">
                                <label class="form-check-label" for="highUnderGradCheckBox">
                                    Undergrad
                                </label>
                            </div>
                            <div class="form-check ml-5">
                                <input class="form-check-input" type="radio" formControlName="highStatus" value="Graduated">
                                <label class="form-check-label" for="highGradCheckBox">
                                    Graduated
                                </label>
                            </div>
                        </div>
                        <div class="col-md-8 row mt-3">
                            <div class="col-md-2 offset-md-1">
                                <label for="">From</label>
                                <label for="">To</label>
                            </div>
                            <div class="col-md-8">
                                <input type="date" class="form-control mt-2" formControlName="highDateFrom">
                                <input type="date" class="form-control mt-2" formControlName="highDateTo">
                            </div>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">College/University</h6>
                    <div class="row">
                        <div class="col-md-12 form-floating">
                            <input type="text" class="form-control" formControlName="collageSchoolNameInput" placeholder="Name">
                            <label for="collageSchoolNameInput">Name & Address of school</label>
                        </div>
                        <div class="col-md-4 mt-3">
                            <div class="form-check ml-5">
                                <input class="form-check-input text-center" type="radio" formControlName="collegeStatus" value="Undergrad"> 
                                <label class="form-check-label" for="collegeUnderGradCheckBox">
                                    Undergrad
                                </label>
                            </div>
                            <div class="form-check ml-5">
                                <input class="form-check-input" type="radio" formControlName="collegeStatus" value="Graduated">
                                <label class="form-check-label" for="collegeGradCheckBox">
                                    Graduate
                                </label>
                            </div>
                        </div>
                        <div class="col-md-8 row mt-3">
                            <div class="col-md-2 offset-md-1">
                                <label for="">From</label>
                                <label for="">To</label>
                            </div>
                            <div class="col-md-8">
                                <input type="date" class="form-control mt-2" formControlName="collegeDateFrom">
                                <input type="date" class="form-control mt-2" formControlName="collegeDateTo">
                            </div>
                        </div>
                    </div>
                    <h6 class="text-center pt-4">Vocational</h6>
                    <div class="row">
                        <div class="col-md-12 form-floating">
                            <input type="text" class="form-control" formControlName="vocationalSchoolNameInput" placeholder="Name">
                            <label for="vocationalSchoolNameInput">Name & Address of school</label>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-6 d-flex align-items-center justify-content-center">
                                <label for="">From</label>
                                <input type="date" class="form-control mt-2" formControlName="vocationalDateFrom">
                            </div>
                            <div class="col-md-6 d-flex align-items-center justify-content-center">
                                <label for="">To</label>
                                <input type="date" class="form-control mt-2" formControlName="vocationalDateto">
                            </div>
                        </div>
                    </div>
                <div class="btn-right d-flex align-items-center justify-content-between">
                    <button progressStepPrev class="btn btn-secondary" type="button">prev</button>
                    <button progressStepNext class="btn btn-primary" type="button">next</button>
                </div>
            </div>
        </app-progress-step>
        <app-progress-step>
            <h2 class="step-header">Employment Record</h2>
            <hr>
            <div class="step-form">
                <div class="full-width row employmentRecord" *ngFor="let empRecord of employmentRecord">
                    <div class="col-md-6 form-floating">
                        <input type="text" class="form-control" formControlName="erEmployersNameInput" placeholder="Employer's Name" name="employersName" required>
                        <label for="erEmployersNameInput">Employer's Name</label>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="text" class="form-control" formControlName="erPlaceInput" placeholder="Place" name="place">
                        <label for="erPlaceInput">Place</label>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="text" class="form-control" formControlName="erPositionInput" placeholder="Position" name="position">
                        <label for="erPositionInput">Position</label>
                    </div>
                    <div class="col-md-6 form-floating">
                        <input type="date" class="form-control" formControlName="erDateInput" placeholder="Date(Month/Year)" name="date">
                        <label for="erDateInput">Date(Month/Year)</label>
                    </div>
                </div>
                <div class="d-grid gap-2">
                    <button type="button" class="btn btn-warning mx-auto" (click)="addEmpRecord()">Add Record</button>
                </div>
                <div class="btn-right d-flex align-items-center justify-content-between">
                    <button type="button" progressStepPrev class="btn btn-secondary" type="button" >prev</button>
                    <button class="btn btn-success" [ngClass]="currentActiveStep != 3 ? 'hide' : 'show'" (click)="onSubmit()">Submit</button>
                    <button type="button" progressStepNext class="btn btn-primary" type="button" [ngClass]="currentActiveStep != 3 ? 'show' : 'hide'">next</button>
                </div>
            </div>
        </app-progress-step>
      </app-progress>
    </form>
    